import { Reports } from '../spot/components/Reports'
import s from './styles.module.scss'

export const ReportsContainer = () => {
  return <Reports />
}
